import { Skeleton } from '@heroui/react'
import React from 'react'

const NftCard3Loader = () => {
  return (
    <>
      <div className="card bg-black rounded-2xl p-3 cursor-pointer">
        <div className="relative flex flex-col justify-end">
          <Skeleton className="w-full h-[8.375rem] rounded-xl dark">
          </Skeleton>
          <div className="card-content rounded-lg bg-[#000000E5] mt-4">
            <Skeleton className="w-[80%] h-3 rounded-md dark">
            </Skeleton>
            <Skeleton className="w-[50%] h-3 mt-1 rounded-md dark">
            </Skeleton>
            <div className="flex items-center justify-between mt-4">
              <Skeleton className="w-full h-8 rounded-lg dark">
              </Skeleton>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default NftCard3Loader;
